// approved recurring values

export const layout = {
  pageMaxWidth: 1200,
    pagePaddingX: {
    xs: 2,
    sm: 3,
    md: 4,
  },
  pagePaddingY: {
    xs: 2,
    md: 4,
  },
  sectionPaddingY: {
    xs: 3,
    md: 4,
  },
  sectionSpacing: {
    xs: 4,
    md: 5,
  },
  gridGap: {
    xs: 3,
    md: 4,
  },
} as const;

export const media = {
  collectionCardAspectRatio: '4 / 3',
  artworkCardAspectRatio: '1 / 1',
  heroAspectRatio: '16 / 9',
} as const;

export const surfaces = {
  cardBorderColor: 'divider',
  mutedBackground: 'grey.100',
} as const;

export const text = {
  muted: 'text.secondary',
  primary: 'text.primary',
} as const;

export const radius = {
  surface: 3, //pixel precision 24
  card: 2,    //pixel precision 16
  button: 1,  //pixel precision 16
} as const;

export const heroColors = {
  bg: '#ece7df',
  overlay: 'rgba(243,239,232,0.38)',
  text: '#131212',
  button: '#345248',
  buttonHover: '#2c463d',
};

export const sectionColors = {
  pageBg: '#f4efe8',
  surface: '#ece7df',
  surfaceAlt: '#e6ded4',
  text: '#131212',
  mutedText: '#5f5a55',
};
export const uiColors = {
  controlBg: '#f3efe8',
  controlBorder: '#cfc3b7',
  controlText: '#6b5a4d',
  controlHoverBg: '#e8dfd4',
};